import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { config } from "../../constants/config";
import Preloader from "../Preloader";
import NetworkError from "../NetworkError";
import { Spinner } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import UserContext from "../../contexts/UserContext";
import AccountUser from "./accountuser";
import { Lock, Person } from "react-bootstrap-icons";
import { textes } from "../../constants/textes";




export default function AccountsUser({codeuser, nameuser, email}) {
    // states
    const {user, logoutUser} = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [addable, setAddable] = useState(false);
    const [error, setError] = useState(false);
    const [accontlist, setAccountlist] = useState([]);
    const [allprofils, setProfilalllist] = useState([]);
    
    const [profils, setProfils] = useState("");
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [confirmpass, setConfirmpass] = useState("");

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const getAccountList = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts/${codeuser}`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        
                        setAccountlist(clientarray);

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });

    }

    const getAllListProfils = async () => {
        // setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        // var urlencoded = new URLSearchParams();
        // urlencoded.append("cpte", user.code);
        // urlencoded.append("prof", user.profil);
        // urlencoded.append("conn", user.token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;
                        
                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({label: element.lib, value: element.code});
                        });

                        let clientarraydata2 = [];
                        await clientarray.forEach(element => {
                            if (element.ident !== "profilsuperadmin") {
                                clientarraydata2.push({label: element.lib, value: element.code});
                            }
                        });

                        if (user?.isFullAction) {
                            setProfilalllist(clientarraydata);
                        } else {
                            setProfilalllist(clientarraydata2);
                        }
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            // setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error: ", err);
                // setLoading(false);
            }

        }).catch((err) => {
            // console.log("cash error: ", err);
            // setLoading(false);
        });

    }
    
    // console.log('name user: ', nameuser);

    // comportements
    useEffect(() => {
        getAccountList();
        getAllListProfils();
    }, []);

    const handleSubmit = async (e) => {

        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();

        urlencoded.append("user", codeuser);
        urlencoded.append("nom", nameuser);
        urlencoded.append("login", login);
        urlencoded.append("mdp", password);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg)
                        }
                    } else {
                        let body = data?.body?.data;
                        handleAffectProfil(body?.creercompte);
                        if (email) {
                            await handleSendMail(config.mailfrom, email, "Identifiants de connexion", "Nom d'utilisateur: " + login + " \nMot de passe: " + password + "\n\nMerci")
                        }
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                setFetching(false);
            }
            
        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(config.texts.unavailblemsg);
            setFetching(false);
        });
    }

    const handleAffectProfil = async (codecompte) => {
        
        // showInfoMessage("En cours d'affectation des droits...");

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        urlencoded.append("prof", profils.map((i) => i["value"]));

        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/workspaces/${user.espace}`, requestOptions).then((response) => {
            if (response?.status !== 200) {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(config.texts.unavailblemsg);
                setFetching(false);
            } else {
                response.json().then(async (data) => {
                    // console.log("resonse affectation profil", data);
                    let body = data?.body;

                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", {state: {msg: config.texts.sessionexpmsg}});
                        } else {
                            setFetching(false);
                            showErrorMessage("Fail to set profiles to acccount.");
                        }
                    } else {
                        setFetching(false);
                        showSuccesMessage("Profiles seted successfully.");
                        setAddable(false);
                        getAccountList();
                    }
                    
                })
            }
            
        })
        .catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(config.texts.unavailblemsg);
            setFetching(false);
        });
    }

    const handleSendMail = async (from, to, subject, text) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Authorization", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.token);

        var urlencoded = new URLSearchParams();
        if (from) urlencoded.append("from", from);
        if (to) urlencoded.append("to", to);
        if (subject) urlencoded.append("subject", subject);
        if (text) urlencoded.append("text", text);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/mail`, requestOptions).then((response) => {
            if (response?.status !== 200) {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            } else {
                response.json().then(async (data) => {
                    // console.log("resonse ajout tarif", data);
                    // let body = data?.body;

                    if (!data?.head) {
                        setFetching(false);
                        showErrorMessage(textes.fr.requestfail)
                    } else {
                        // setFetching(false);
                        // showSuccesMessage(textes.fr.controleaddedlabel);
                        // navigate(-1, { state: { page: 0 } });
                    }

                })
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    }

    // console.log("objet list: ", rulesobjectlist);

    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row">
                <div className="col-md-12 mb-3 pt-3 rounded" style={{borderTop: "1px solid #ccc"}}>
                    <div className="row">
                        {/* <div className="col-md-2 mb-3">  
                            <PaginationSelect table={"scan"} getList={getAccountList} page={page} setPage={setPage} limit={100} current={currentpage} setCurrent={setCurrentpage} />
                        </div>
                        <div className="col-md-10 mb-3">
                            <Search 
                                chaine={chaine}
                                setChaine={setChaine}
                                search={searchScan}
                                placeholder="Search by access name..."
                            />
                            <Filterdate 
                                date={date}
                                setDate={setDate}
                                filterdate={filterByDate}
                                placeholder="Filter by date..."
                            />
                            <Filterselect 
                                list={list}
                                item={mode}
                                setItem={setMode}
                                filterselect={filterByMode}
                                placeholder="Filter by access types..."
                            />
                        </div> */}
                        {!addable && <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    <button type="button" data-toggle="tooltip" onClick={() => setAddable(true)}
                                        title="New account" 
                                        data-placement="left" className="btn-shadow ml-3 btn btn-primary btn-sm float-right">
                                        <i className="fa fa-plus mr-1"></i> <span>New account</span>
                                    </button>
                                    <h6 className="m-0 ">List of user's accounts</h6>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive mb-3">
                                        <table className="mb-0 table table-bordered">
                                            <thead className="bg-primary">
                                                <tr className="bg-primary text-white">
                                                    <th className="text-center">#</th>
                                                    <th>Username</th>
                                                    {/* <th>Code action</th> */}
                                                    {/* <th>Parent</th> */}
                                                    <th>State</th>
                                                    <th>Added date</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(accontlist.length === 0) && <tr style={{borderStyle: "none"}}>
                                                    <th colSpan={5} className="text-center">No account found for this user</th>
                                                </tr>}
                                                {
                                                    (accontlist.length > 0) && accontlist?.map((item, index) => (
                                                        <AccountUser account={item} position={index} key={index} 
                                                            // deleteClick={() => handleDelete(item?.code)}
                                                        />
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <Pagination table={"client"} getList={getAccountList} page={page} setPage={setPage} /> */}
                                </div>
                            </div>
                        </div>}

                        {addable && <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    <button type="button" data-toggle="tooltip" onClick={() => setAddable(false)}
                                        title="Cancel the add" 
                                        data-placement="left" className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                        <i className="fa fa-backward mr-1"></i> <span>Cancel</span>
                                    </button>
                                    <h6 className="m-0 ">Add an account to this user</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{width: "100%"}} onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="row">

                                                    <div className="col-md-12 mb-3">
                                                        <label className="mb-1" htmlFor="parent">Profiles</label>
                                                        <Select
                                                            id="parent"
                                                            name="parent"
                                                            options={allprofils}
                                                            value={profils}
                                                            placeholder="Select account profiles"
                                                            onChange={(selected) => { 
                                                                setProfils(selected);
                                                            }}
                                                            isMulti
                                                        />
                                                    </div>
                                                    
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="login" className="mb-1">Username</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="login">
                                                                <Person />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder="Enter username"
                                                                value={login}
                                                                onChange={(e) => setLogin(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="pass" className="mb-1">Password</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="pass">
                                                                <Lock />
                                                            </span>
                                                            <input type="password" 
                                                                className="form-control" 
                                                                placeholder="Enter account passworde"
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="confirmpass" className="mb-1">Confirme password</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="confirmpass">
                                                                <Lock />
                                                            </span>
                                                            <input type="password" 
                                                                className="form-control" 
                                                                placeholder="Enter password confirmation"
                                                                value={confirmpass}
                                                                onChange={(e) => setConfirmpass(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-2">
                                                <button type="submit" 
                                                    title="Add account" 
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                    disabled={profils && login && password && password === confirmpass ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i> 
                                                    <span>Add account</span> {fetching && <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                    />}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>}
                        
                    </div>
                </div>
            </div>} 
        </>
    )
    
}